import { DM_DuyetChiTiet } from './../kho-de-nghi-xuat-kho-model/kho-de-nghi-xuat-kho.model';
import { DeNghiMuaHangService } from '../../../mua-hang/de-nghi-mua-hang/de-nghi-mua-hang-service/de-nghi-mua-hang.service';
import {Component,
		OnInit,
		ElementRef,
		ViewChildren,
		ViewChild,
		ChangeDetectionStrategy,
		ChangeDetectorRef,
		Inject
	}
from '@angular/core';
import { DatePipe } from '@angular/common';
// Material
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//Service
import { KhoDeNghiXuatKhoService } from '../kho-de-nghi-xuat-kho-service/kho-de-nghi-xuat-kho.service';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';

import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { KhoDeNghiXuatKho, KhoDeNghiXuatKhoChiTiet} from '../kho-de-nghi-xuat-kho-model/kho-de-nghi-xuat-kho.model';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import moment from 'moment';

@Component({
	selector: 'm-kho-de-nghi-xuat-kho-duyet',
	templateUrl: './kho-de-nghi-xuat-kho-duyet.component.html',
	styleUrls: ['../kho-de-nghi-xuat-kho.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class KhoDeNghiXuatKhoDuyetComponent implements OnInit {
	//#region Config
	CONFIG: CommonConFig;
	//#endregion Config

	//#region Các trường focus cho các tag trong form 
	@ViewChildren('focusLyDo') focusLyDo;
	/* Trigger menu hiển thị cột cho danh sách */
	@ViewChild('trigger', {static: true}) _trigger: MatMenuTrigger;
	//#endregion Các trường focus cho các tag trong form 

	//#region Column Table
	displayedColumns = [];
	availableColumns = [
		{
			stt: 0,
            name: 'select',
            displayName: 'Check chọn',
			alwaysChecked: true,
			isShow: true
        },
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MAHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TENHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QUYCACH',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 5,
            name: 'DONVITINH',
            displayName: 'Đơn vị tính',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SOLUONG',
            displayName: 'SL',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SOLUONGTHUCXUAT',
            displayName: 'SL thực xuất',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'BPDN',
            displayName: 'Bộ phận đề nghị',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'BPSD',
            displayName: 'Bộ phận sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'MUCDICHSUDUNG',
            displayName: 'Mục đích sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SOLO',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SOMAY',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 9,
            name: 'NGAYCAN',
            displayName: 'Ngày cần',
            alwaysChecked: false,
			isShow: true
		},
		// {
        //     stt: 10,
        //     name: 'GHICHU',
        //     displayName: 'Ghi chú',
        //     alwaysChecked: false,
		// 	isShow: true
		// },
		// {
        //     stt: 10,
        //     name: 'SOPHIEUDHB',
        //     displayName: 'Số phiếu ĐHB',
        //     alwaysChecked: false,
		// 	isShow: true
		// },
		// {
        //     stt: 10,
        //     name: 'MAKH',
        //     displayName: 'Mã KH',
        //     alwaysChecked: false,
		// 	isShow: true
		// },
		// {
        //     stt: 10,
        //     name: 'TENKH',
        //     displayName: 'Tên KH',
        //     alwaysChecked: false,
		// 	isShow: true
		// },
		{
            stt: 10,
            name: 'NGUOIDUYET',
            displayName: 'Người duyệt',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'NGAYDUYET',
            displayName: 'Ngày duyệt',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'KETQUA',
            displayName: 'Kết quả',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'LYDO',
            displayName: 'Ghi chú kết quả duyệt',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'ACTIONS',
            displayName: '',
            alwaysChecked: false,
			isShow: true
		},
	];
	

	//#endregion Column Table

	//#region Mat Select
	/* Mat select search cho khach hang */
	listListKH : any[] = [];
	selectListKH : string = '';
	filteredListKH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListKHFilterCtrl: string = '';
	haveElementListKH: boolean = false;
	/* ------------------------------------------------------------------ */
	/* Mat select search cho hàng hóa */
	listId_HH : any[] = [];
	selectId_HH : string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	/* ------------------------------------------------------------------ */
	//#endregion Mat Select
	
	//#region Khai báo biến
	/* Giá trị đầu tiên cho dropdown quyết định nhập hàng - Form QC kiểm tra*/
	processImport: boolean = true;		// Có đang chạy import
	/* ------------------------------------------------------------------ */

	/* Selection */
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<KhoDeNghiXuatKhoChiTiet>(true, []);
	/* ------------------------------------------------------------------ */

	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	/* Extend field:  */
	previousIndex: number; 			// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                 // Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;		// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	isZoomSize: boolean = false;    // Trường đánh dấu có đang ở trạng thái zoom size hay không
	saveAddedTTHV: number[] = []	// Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = true;   // Loading khi mở dialog
	canEdit: boolean = false;		// Dialog có thể chỉnh sửa không?
	/* ------------------------------------------------------------------ */

	/* Các Sub form trên dialog:  */
	KhoDeNghiXuatKhoForm: FormGroup;				//Form phiếu đề nghị
	hasFormErrors: boolean = false;

	KhoDeNghiXuatKhoSubForm: FormGroup;				//Form phiếu đề nghị
	hasSubFormErrors: boolean = false;

	ImportHHForm: FormGroup;
	/* ------------------------------------------------------------------ */

	/* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
	KhoDeNghiXuatKhoItem: KhoDeNghiXuatKho;

	/* Danh sách tạm chi tiết hàng hóa của phiếu đề nghị dùng để cập nhập trên lưới  */
	tmpChiTietKhoDeNghiXuatKho: KhoDeNghiXuatKhoChiTiet[] = [];

	apiListChiTiet: KhoDeNghiXuatKhoChiTiet[] = [];

	/* Danh sách tình trạng phiếu */
	Tinhtrang = [
		{
			id: 1,
			name: 'Đang soạn thảo',
			value: 'KHOPDNXK_LUUNHAP',
		},
		{
			id: 2,
			name: 'Chờ duyệt',
			value: 'KHOPDNXK_CHODUYET',
		},
		{
			id: 3,
			name: 'Bị trả lại',
			value: 'KHOPDNXK_BITRALAI',
		},
		{
			id: 4,
			name: 'Hoàn tất',
			value: 'KHOPDNXK_HOANTAT',
		},
		{
			id: 5,
			name: 'Đã hủy',
			value: 'KHOPDNXK_DAHUY',
		},
		{
			id: 6,
			name: 'Chờ xuất kho',
			value: 'KHOPDNXK_CHOXUATKHO',
		},
	];
	//#endregion Khai báo biến

	nguoiTao : boolean = false;

	//#region Constructor
	constructor(
		public dialogRef: MatDialogRef<KhoDeNghiXuatKhoDuyetComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private KhoDeNghiXuatKhoService: KhoDeNghiXuatKhoService,
		private DungChungService: DungChungService,
		public dialog: MatDialog,
		private KhoDeNghiXuatKhoFB: FormBuilder,
		private KhoDeNghiXuatKhoSubFB: FormBuilder,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private el: ElementRef,
		private deNghiMuaHangService: DeNghiMuaHangService
	) { this.dialogRef.disableClose = true;}
	//#endregion Constructor

	//#region Load Data
	ngOnInit() {
		this.viewLoading = true;
		this.processImport = false;
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();

		/*Get data from list when open dialog */
		this.KhoDeNghiXuatKhoItem = this.data.data;
		this.canEdit = this.data.canEdit;
		this.nguoiTao = this.data.nguoiTao ? this.data.nguoiTao : false;

		/*Load all dropdown and create form */
		this.ListKH();
		this.createForm();
		/*Handel escape event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.keyCode == this.CONFIG.BUTTON_FORM.BACK.KeyCombine.keycode) {
				this.back();
			}
			if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_TMP.KeyCombine.keycode && this.selection.selected.length > 0) {
				this.dongDeNghi();
			}
			
		});
		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
		this.changeDetect.detectChanges();
	}

	ngAfterViewInit() {
		this.changeDetect.detectChanges();
	}
	
	//#endregion Load Data

	//#region Tạo form
	createForm(){
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		var idPhongBan = '';
		var IdUser = 0;
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
		this.tokenStorage.getIDUser().subscribe(t => { IdUser = +t; });
		this.tokenStorage.getCoCauId().subscribe(a => {idPhongBan = ''+a;});

		/*Group các Form */
		this.KhoDeNghiXuatKhoForm = this.KhoDeNghiXuatKhoFB.group({
			SOPHIEU: [this.KhoDeNghiXuatKhoItem.Sophieu, Validators.required],
			NGAYLAP: [!(this.KhoDeNghiXuatKhoItem.Ngaytao == undefined || this.KhoDeNghiXuatKhoItem.Ngaytao == '') ? this.KhoDeNghiXuatKhoItem.Ngaytao : new Date(), Validators.required],
			NGUOILAP: [this.KhoDeNghiXuatKhoItem.Nguoitao > 0 ? this.KhoDeNghiXuatKhoItem.TenNguoitao : tenNguoiLap],
			TRANGTHAI: [(this.KhoDeNghiXuatKhoItem.Tinhtrang == '')? this.Tinhtrang[0].value: this.KhoDeNghiXuatKhoItem.Tinhtrang],
			DESCTRANGTHAI: [(this.KhoDeNghiXuatKhoItem.DescTinhTrang == '')?  this.Tinhtrang[0].name: this.KhoDeNghiXuatKhoItem.DescTinhTrang],
			LOAIPHIEU: [(!this.KhoDeNghiXuatKhoItem.TenLoaiPhieu)? '' : ''+this.KhoDeNghiXuatKhoItem.TenLoaiPhieu]
		});
		// this.KhoDeNghiXuatKhoSubForm = this.KhoDeNghiXuatKhoSubFB.group({
		// 	NGUOIDUYET: [(this.KhoDeNghiXuatKhoItem.Nguoiduyet == 0 || this.KhoDeNghiXuatKhoItem.Nguoiduyet == null || this.KhoDeNghiXuatKhoItem.Nguoiduyet == undefined)? tenNguoiLap : this.KhoDeNghiXuatKhoItem.TenNguoiduyet],
		// 	NGAYDUYET: [!(this.KhoDeNghiXuatKhoItem.Ngayduyet == '' || this.KhoDeNghiXuatKhoItem.Ngayduyet == null || this.KhoDeNghiXuatKhoItem.Ngayduyet == undefined)? this.KhoDeNghiXuatKhoItem.Ngayduyet : new Date()],
		// 	LYDO: [(this.KhoDeNghiXuatKhoItem.Lydokhongduyet == '' || this.KhoDeNghiXuatKhoItem.Lydokhongduyet == null || this.KhoDeNghiXuatKhoItem.Lydokhongduyet == undefined)?  '' : this.KhoDeNghiXuatKhoItem.Lydokhongduyet],
		// });
		// /*Disable các trường dữ liệu không thay đổi */
		this.KhoDeNghiXuatKhoForm.controls["SOPHIEU"].disable();
		this.KhoDeNghiXuatKhoForm.controls["NGUOILAP"].disable();
		this.KhoDeNghiXuatKhoForm.controls["NGAYLAP"].disable();
		this.KhoDeNghiXuatKhoForm.controls["DESCTRANGTHAI"].disable();
		this.KhoDeNghiXuatKhoForm.controls["LOAIPHIEU"].disable();

		// this.KhoDeNghiXuatKhoSubForm.controls["NGUOIDUYET"].disable();
		// this.KhoDeNghiXuatKhoSubForm.controls["NGAYDUYET"].disable();

		this.apiListChiTiet = [];
		this.KhoDeNghiXuatKhoItem.ChiTiet.forEach(x =>{
			this.apiListChiTiet.push(x);
		})

		this.tmpChiTietKhoDeNghiXuatKho = this.KhoDeNghiXuatKhoItem.ChiTiet;
		this.tmpChiTietKhoDeNghiXuatKho.forEach(x => {
			x.XuLy.PhieuDeNghi = x.IdDn;
			x.XuLy.PhieuDeNghiCT = x.IdCtdn;
			x.XuLy.TenNguoiDuyet = x.XuLy.TenNguoiDuyet? x.XuLy.TenNguoiDuyet : this.nguoiTao? '' : tenNguoiLap;
			x.XuLy.NgayDuyetDate = x.XuLy.NgayDuyet? new Date(x.XuLy.NgayDuyet): this.nguoiTao? null : new Date();
			x.XuLy.LyDo = x.XuLy.LyDo? x.XuLy.LyDo : '';
		})
		this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];

	}
	//#endregion Tạo form

	//#region Tiêu đề page
	getTitle(): string {
		return `XỬ LÝ PHIẾU ĐỀ NGHỊ XUẤT KHO `;
	}
	//#endregion Tiêu đề page

	//#region Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng
    showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	//#endregion Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng

	//#region Lấy phòng ban
	ListKH(select: boolean = false){
		
		this.DungChungService.listPB().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.viewLoading = false;
				this.listListKH = res.data;
				this.filteredListKH.next(this.listListKH.slice());
				this.changeDetect.detectChanges();

			};
		});
	}

	filterListKH() {
		if (!this.listListKH) {
			return;
		}
		// get the search keyword
		let search = this.ListKHFilterCtrl;
		if (!search) {
			this.filteredListKH.next(this.listListKH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListKH.next(
			this.listListKH.filter(ts =>
				ts.MaKH.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	//#endregion Lấy phòng ban

	//#region Hỗ trợ format dữ liệu form, validate
	changeValueOfForm(controlName: string, event: any){
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = this.KhoDeNghiXuatKhoSubForm.controls[controlName].value.replace(/,/g, "");
			if(!this.KhoDeNghiXuatKhoSubForm.controls['KHOILUONG'].invalid){
				this.KhoDeNghiXuatKhoSubForm.controls[controlName].setValue(
					this.f_currency(this.formatNumber(tmpValue))
				);
			}
			if(tmpValue.indexOf('.') == 0 && tmpValue.length == 1){
				tmpValue = 0;
			}
			this.KhoDeNghiXuatKhoSubForm.controls[controlName].setValue(
				this.f_currency(this.formatNumber(tmpValue))
			);
		}
		else{
			this.KhoDeNghiXuatKhoSubForm.controls[controlName].setValue(''+event.target.value);
		}
	}

	ValidateChangeNumberForm(event: any, isEvent:boolean = true) {
		
		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == '.'){
					count += 1;
				}
			}
		}
		else{
			for(let i = 0; i < event.length; i++){
				if(event[i] == '.'){
					count += 1;
				}
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}

	formatNumber(item: string){
		if(item == '' || item == null || item == undefined)	return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint)
	}

	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}

	f_currency_V2(value: string): any {
		if(value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}

	getFormatDate(v: string = '') {
        if (v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}

	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}

	dateToDDMMYYYY(__data: any){
		let __date = new Date(__data);
		return ("0" + __date.getDate()).slice(-2)+"/"+("0" + (__date.getMonth() + 1)).slice(-2)+"/"+__date.getFullYear();
	}

	formatComparenumber(number: string){
		return +number.replace(/,/g, "");
	}
	//#endregion Hỗ trợ format dữ liệu form , validate

	//#region Chuyển trạng thái phiếu
	checkGuiDuyet(checked: boolean = false){
		if(checked){
			this.KhoDeNghiXuatKhoForm.controls['DESCTRANGTHAI'].setValue(this.Tinhtrang[1].name);
			this.KhoDeNghiXuatKhoForm.controls['TRANGTHAI'].setValue(this.Tinhtrang[1].value);
		}else{
			this.KhoDeNghiXuatKhoForm.controls['DESCTRANGTHAI'].setValue(this.Tinhtrang[0].name);
			this.KhoDeNghiXuatKhoForm.controls['TRANGTHAI'].setValue(this.Tinhtrang[0].value);
		}
	}
	//#endregion Chuyển trạng thái phiếu

	//#region Thoát form
	back(){
		this.dialogRef.close({
			isChange: this.isChange,
			dataAdd : this.saveAddedTTHV
		});
	}
	//#endregion Thoát form
	
	//#region Xư lý duyệt, không duyệt
	onSubmit(action: boolean) { // true là duyệt false là không duyệt
		this.hasFormErrors = false;
		const controls = this.KhoDeNghiXuatKhoSubForm.controls;
		/** check form */
		if(action == false){
			this.KhoDeNghiXuatKhoSubForm.controls['LYDO'].setValidators([Validators.compose([Validators.required])]);
			this.KhoDeNghiXuatKhoSubForm.controls['LYDO'].updateValueAndValidity();
			
			if (this.KhoDeNghiXuatKhoSubForm.invalid) {
				Object.keys(controls).forEach(controlName =>
					controls[controlName].markAsTouched()
				);
				setTimeout(() => this.focusLyDo.first.nativeElement.focus(), 500);
				this.hasFormErrors = true;
				return;
			}
		}
		this.processImport = true;
		const _sophieu = this.KhoDeNghiXuatKhoItem.Sophieu;
		if(action){
			this.KhoDeNghiXuatKhoSubForm.controls['LYDO'].clearValidators();
			this.KhoDeNghiXuatKhoSubForm.controls['LYDO'].updateValueAndValidity();
			const dialogRef = this.layoutUtilsService.POP03(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					this.processImport = false;
					this.changeDetect.detectChanges();
					return;
				}
				this.KhoDeNghiXuatKhoItem.Lydokhongduyet = controls['LYDO'].value;
				this.KhoDeNghiXuatKhoService.accept(this.KhoDeNghiXuatKhoItem).subscribe(res =>{
					this.processImport = false;
					if(res && res.status === 1){
						const message = 'Phiếu đề nghị xuất kho ' +_sophieu+' cập nhật thành công.';
						this.layoutUtilsService.showInfo(message);
						this.KhoDeNghiXuatKhoForm.reset();
						this.tmpChiTietKhoDeNghiXuatKho = [];
						this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
						this.isChange = true;
						this.saveAddedTTHV = [res.data.IdDn];
						this.back();
					}else{
						this.layoutUtilsService.showErorr(res.error.message);
					}
					
				});
			});

		}else{
			const dialogRef = this.layoutUtilsService.POP02(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					this.processImport = false;
					this.changeDetect.detectChanges();
					return;
				}
				this.KhoDeNghiXuatKhoItem.Lydokhongduyet = this.KhoDeNghiXuatKhoSubForm.controls['LYDO'].value;
				this.KhoDeNghiXuatKhoService.reject(this.KhoDeNghiXuatKhoItem).subscribe(res =>{
					this.processImport = false;
					if(res && res.status === 1){
						const message = 'Phiếu đề nghị xuất kho ' +_sophieu+' cập nhật thành công.';
						this.layoutUtilsService.showInfo(message);
						this.KhoDeNghiXuatKhoForm.reset();
						this.tmpChiTietKhoDeNghiXuatKho = [];
						this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
						this.isChange = true;
						this.saveAddedTTHV = [res.data.IdDn];
						this.back();
					}else{
						this.layoutUtilsService.showErorr(res.error.message);
					}
				});
			});


		}
	}
	//#endregion Xư lý duyệt, không duyệt

	//#region Reset Form
	resetSubForm(){
		this.KhoDeNghiXuatKhoSubForm.reset();
		this.KhoDeNghiXuatKhoSubForm.controls['SOLUONG'].setValue("0.00");
		this.KhoDeNghiXuatKhoSubForm.controls['SLTON'].setValue("0.00");
		this.KhoDeNghiXuatKhoSubForm.controls['NGAYCAN'].setValue(new Date());
	}
	//#endregion Reset Form

	luuKetQuaDuyet(item: KhoDeNghiXuatKhoChiTiet){
		item.XuLy.NgayDuyet = moment(item.XuLy.NgayDuyetDate).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		const sophieu = this.KhoDeNghiXuatKhoItem.Sophieu;
		const dialogRef = this.layoutUtilsService.POP02(sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					this.changeDetect.detectChanges();
					return;
				}
				this.KhoDeNghiXuatKhoService.luuKetQuaDuyet(item.XuLy).subscribe(res =>{
					if(res && res.status === 1){
						const message = 'Cập nhật kết quả duyệt thành công.';
						this.layoutUtilsService.showInfo(message);
						item.XuLy.Id = res.data;
						this.layDuLieuPhieu(this.KhoDeNghiXuatKhoItem.IdDn);
					}else{
						this.layoutUtilsService.showErorr(res.error.message);
						if(res.status == -1) this.layDuLieuPhieu(this.KhoDeNghiXuatKhoItem.IdDn);
					}
				});
			});
	}

	xacNhanNhanHang(item: KhoDeNghiXuatKhoChiTiet){
		item.XuLy.ListXacNhanNhanHang = [];
		item.XuLy.ListXacNhanNhanHang.push(item.XuLy.PhieuDeNghiCT);
		this.KhoDeNghiXuatKhoService.xacNhanNhanHang(item.XuLy).subscribe(res =>{
			if(res && res.status === 1){
				const message = 'Cập nhật thành công.';
				this.layoutUtilsService.showInfo(message);
				if(res.data){
					this.layDuLieuPhieu(this.KhoDeNghiXuatKhoItem.IdDn);
				}
			}else{
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}

	dongDeNghi(){
		let item = new DM_DuyetChiTiet();
		item.clear();
		item.PhieuDeNghi = this.KhoDeNghiXuatKhoItem.IdDn;
		let flag = true;
		this.selection.selected.forEach(x => {
			
			if(!x.XuLy.CoKetQuaDuyet || (x.XuLy.CoKetQuaDuyet && x.XuLy.LoaiThaoTac != 'KHODNXK_DUYETCT'))
				flag = false;	
		});
		if(!flag){
			this.layoutUtilsService.showErorr("Tồn tại chi tiết đề nghị xuất kho không hợp lệ!");
			return false;
		}
		item.ListXacNhanNhanHang = this.selection.selected.map(x => x.IdCtdn);
		this.KhoDeNghiXuatKhoService.xacNhanNhanHang(item).subscribe(res =>{
			if(res && res.status === 1){
				const message = 'Cập nhật thành công.';
				this.layoutUtilsService.showInfo(message);
				this.isChange = true;
				this.saveAddedTTHV = [item.PhieuDeNghi];
				this.layDuLieuPhieu(this.KhoDeNghiXuatKhoItem.IdDn);
				//this.back();
			}else{
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});

	}

	async layDuLieuPhieu(id){
		let res = await this.KhoDeNghiXuatKhoService.detail(id).toPromise();
		if(res && res.status == 1){
			this.KhoDeNghiXuatKhoItem = res.data;
			this.createForm();
			this.isChange = true;
			this.saveAddedTTHV = [this.KhoDeNghiXuatKhoItem.IdDn];
			this.changeDetect.detectChanges();
		}
	}

	disabledButton(item, index: number){
		var itemAPI = this.apiListChiTiet[index];
		if(this.KhoDeNghiXuatKhoItem.Tinhtrang != this.Tinhtrang[1].value) return true;
		if(itemAPI.XuLy.CoKetQuaDuyet) return true;
		if(!itemAPI.XuLy.LoaiThaoTac) return true;
		if(item.XuLy.LoaiThaoTac == 'KHODNXK_KHONGDUYETCT' && item.XuLy.LyDo.length == 0) return true;
		return false;
	}

	isAllSelected() {
		const numSelected = this.selection.selected.length;
		let __listCheck = this.tmpChiTietKhoDeNghiXuatKho.filter(x => x.XuLy.CoKetQuaDuyet && x.XuLy.LoaiThaoTac == 'KHODNXK_DUYETCT' && !x.DaLapPhieuXuatKho);
        const numRows = __listCheck.length;
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        if (this.isAllSelected()) {
            this.selection.clear();
        } else {
			let __listCheck = this.tmpChiTietKhoDeNghiXuatKho.filter(x => x.XuLy.CoKetQuaDuyet && x.XuLy.LoaiThaoTac == 'KHODNXK_DUYETCT' && !x.DaLapPhieuXuatKho);
            __listCheck.forEach(row => this.selection.select(row));
        }
	}
	
	disabledCheckBoxMaster(){
		let __listCheck = this.tmpChiTietKhoDeNghiXuatKho.filter(x => x.XuLy.CoKetQuaDuyet && x.XuLy.LoaiThaoTac == 'KHODNXK_DUYETCT' && !x.DaLapPhieuXuatKho);
		return __listCheck.length == 0;
	}
	
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return '0,00';
		return new Intl.NumberFormat('de-DE',{ style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
}

